import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { MapService } from './map.service';
import { ToolsControlService } from './tools-control.service';
import olMap from 'ol/Map';
import { ConfigurationService } from './configuration.service';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { Layer } from '../menu/view-menu/layer';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { TabsService } from './tabsService';
import {clone, filter} from 'lodash';
import { NavaidTypes } from '../models/EnumTypes';
import { NavaidModel } from '../models/navaid';
import { Options } from '@angular-slider/ngx-slider';
import {hide} from "@popperjs/core";

@Injectable({
  providedIn: 'root'
})
export class AnalysisToolService {

  active : boolean;
  fullScreenMode : boolean = false;

  layers: Layer[] = []
  features: Feature<Geometry>[] = [];
  calcType: string
  title: string


  sliderValue: number = 0;

  navaids_info: Map<string, String[]> = new Map<string, String[]>();
  selectedNavaid: string;
  sliderValues: String[] = [];
  selectedElevation: String;

  map: olMap;

  previouslyModifiedFeatures: Feature<Geometry>[] = [];
  savedStyles:(() => Style[])[]  = [];

  hiddenFeatures: Feature<Geometry>[] = [];
  hiddenFeaturesStyles: (() => Style[])[]  = [];

  layerName?: string;

  // Pair analysis ////////////////////////////////////
  selectedNavaids: string[];
  criticallity: string;
  criticalNavaids: string[] = [];
  previouslySelectedFeatures: Feature<Geometry>[] = [];
  private static readonly PAIRS_ANALYSIS_FLAG: string = 'Available Pairs Analysis';
  ////////////////////////////////////////////////////

  private static readonly ANALYSIS_TOOL_COLOR: string = 'red';
  
  sliderOptions: Options = {
    floor: 0,
    ceil: 4,
    step: 1,
    showTicks: true,
    tickValueStep: 1,
    getPointerColor: () => '#3f51b5',
      translate: (value: number): string => {
      return ''; // removes the top label
    }
  };


  constructor(private toolsService: ToolsControlService,
              private mapService: MapService,
              private configurationService: ConfigurationService,
              private globalSelectionService: GlobalSelectionControlService
              )
              {
                this.map = this.mapService.getMap('map');
              }

  openWindow(calcId: number, layerName?: string){
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.selectedNavaid = "ALL"; // default value
    this.criticallity = "ALL"; // default value
    this.criticalNavaids = [];
    this.features = [];

    const calculation = this.globalSelectionService.calculationLayers.childLayers.find(layer => layer.calcID == calcId);
    this.calcType = calculation.type;
    if (calculation.type == "PERFORMANCE"){
      this.layerName = layerName;
      if (this.isPairsAnalysis()){
        this.layers = calculation.layers.filter(layer => layer.name == "Available Pairs");
      }else {
        this.layers = calculation.layers.filter(layer => layer.name == layerName);
      }
    } else {
      this.layers = calculation.layers;
    }

    this.setFeatures();

    this.title = this.calcType.charAt(0) + this.calcType.substring(1).toLowerCase() + " Analysis";
    if (calculation.type == "DocAndSectorizationDisplay"){
      this.title = "DOC and Sectorization Analysis";
      this.navaids_info = calculation.navaids_info;
    } else if (calculation.type == "Coverage" ) {
      this.navaids_info = this.getNavaidsInfo();
    } else if (calculation.type == "PERFORMANCE"){
      if (this.isPairsAnalysis()){
        this.title = layerName;
        this.setNavaidInfoForPairsAnalysis();
      }else {
        this.title += " " + layerName;
      }
    }

    //#region GRIT
    else if (calculation.type == "Impact Assessment" ) {
      this.title = "Impact Assessment Analysis";

      const navaids_info: Map<string, String[]> = new Map<string, String[]>();
      for (const feat of this.features){
        let type = String(feat.getProperties()['ID'])
          .split("_", 1).at(0)
          .split("-")?.at(2) ?? "J";

        let key = `${feat.getProperties().NA}_${type}`;

        if (!navaids_info.has(key)){
          navaids_info.set(key, [feat.getProperties().ELEV]);
        } else {
          const elevationsNav = navaids_info.get(key);
          if (!elevationsNav.includes(feat.getProperties().ELEV)){
            elevationsNav.push(feat.getProperties().ELEV);
          }

        }
      }

      this.navaids_info = navaids_info;
    }
    //endregion

    if (!this.isPairsAnalysis()){
      this.onSelectChange();
    }
  }

  private setFeatures(){
    for (const layer of this.layers){
      const features = layer.olLayer.getSource().getFeatures();
      if (features && features.length > 0){
        this.features.push(...features);
      }
    }
  }

  private getNavaidsInfo(): Map<string, String[]>{
    const navaids_info: Map<string, String[]> = new Map<string, String[]>();
    for (const feat of this.features){
      if (!navaids_info.has(feat.getProperties().NA)){
        navaids_info.set(feat.getProperties().NA, [feat.getProperties().ELEV]);
      } else {
        const elevationsNav = navaids_info.get(feat.getProperties().NA);
        if (!elevationsNav.includes(feat.getProperties().ELEV)){
          elevationsNav.push(feat.getProperties().ELEV);
        }

      }
    }
    return navaids_info;
  }

  onSelectChange(){
    this.sliderValues = [];

    if (this.selectedNavaid == "ALL" && this.isImpactAssessment()){
      let elevations = []
      this.info.forEach((value: String[]) => {elevations.push(...value);})
      for (const elevation of elevations){
        this.sliderValues.includes(elevation)? false : this.sliderValues.push(elevation);
      }
    }
    else if (this.selectedNavaid == "ALL" || !this.isNavaidDiscreteCalculation()){
      for (const feat of this.features){
        let elevation: string;
        if (!this.isNavaidDiscreteCalculation()){
          elevation = feat.getProperties().ELEVATION;
        } else {
          elevation = feat.getProperties().ELEV;
        }
        this.sliderValues.includes(elevation)? false : this.sliderValues.push(elevation);
      }
    }
    else {
      for (const elevation of this.navaids_info.get(this.selectedNavaid)){
        this.sliderValues.includes(elevation)? false : this.sliderValues.push(elevation);
      }
    }
    this.sliderValues.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
    this.selectedElevation = this.sliderValues[0];
    this.sliderValue = 0;
    this.updateSliderOptions();
    this.onSliderChange();
  }

  updateSliderOptions(): void {
    this.sliderOptions = {
      floor: 0,
      ceil: this.sliderValues.length - 1,
      step: 1,
      showTicks: true,
      tickValueStep: 1,
      getPointerColor: () => '#3f51b5',
      translate: (value: number): string => {
        return ''; // removes the top label
      }
    };
  }


  hideExcludedFeatures(){
    if (this.selectedNavaid != "ALL" || !this.isNavaidDiscreteCalculation() || (this.selectedNavaid == "ALL" && this.isImpactAssessment())){
      for (const feat of this.features){
        let hideFeature: boolean;
        if (this.calcType == "Coverage"){
          hideFeature = feat.getProperties().NA != this.selectedNavaid;
        } else if (this.isPairsAnalysis()) {
          if (this.isCritical()){
            hideFeature = true;
            for (const criticalNav of this.criticalNavaids){
              hideFeature = hideFeature && !this.isFeatureCritical(feat, criticalNav);
            }
          } else {
            hideFeature = true;
            for (const navSelected of this.selectedNavaids){
              const featurePairs: Pair[] = this.parseFeaturePairs(feat);
              const pairsIncludeNav: boolean = featurePairs.find(pair => pair.left == navSelected || pair.right == navSelected) != null;
              hideFeature = hideFeature && !pairsIncludeNav;
            }
          }

        }
        else if (this.calcType == "Impact Assessment"){
          let featType = String(feat.getProperties()['ID'])
            .split("_", 1).at(0)
            .split("-")?.at(2) ?? "J";
          if (this.selectedNavaid == "ALL"){
            hideFeature = !this.typeDisplay.includes(featType);
          }else{
            hideFeature = `${feat.getProperties().NA}_${featType}` != this.selectedNavaid
          }
        }
        else {
          hideFeature = feat.getProperties().ELEVATION != this.selectedElevation;
        }

        if (hideFeature){
          const changedFeatureIndex = this.previouslyModifiedFeatures.findIndex(f => f.getProperties().ID == feat.getProperties().ID);
          if (changedFeatureIndex > -1){
            this.hiddenFeaturesStyles.push(this.savedStyles[changedFeatureIndex]);
          } else {
            this.hiddenFeaturesStyles.push(feat.getStyle() as () => Style[]);
          }

          this.hiddenFeatures.push(feat);
          feat.setStyle(function() {});
        }
      }
    }
  }

  showHiddenFeatures(){
    for (let i=0; i<this.hiddenFeatures.length; i++){
      this.hiddenFeatures[i].setStyle(this.hiddenFeaturesStyles[i]);
    }
    this.hiddenFeatures = [];
    this.hiddenFeaturesStyles = [];
  }

  onSliderChange(){
    this.selectedElevation = this.sliderValues[this.sliderValue];
    if (this.calcType != "DocAndSectorizationDisplay"){
      this.showHiddenFeatures();
      this.hideExcludedFeatures();
    }
    if (!this.isNavaidDiscreteCalculation){
      return;
    }

    this.changeCalculationOnMap();
  }

  private changeCalculationOnMap(){
    const toBeChangedFeatures = this.features.filter(feat => this.isFeatureOnList(feat));
    this.restorePreviouslyChangedFeatures(toBeChangedFeatures);
    this.changeFeaturesStyle(toBeChangedFeatures);
  }

  private isFeatureOnList(feature: Feature<Geometry>): boolean{
    if (this.selectedNavaid == "ALL"){
      if (this.isImpactAssessment()){
        let featType = String(feature.getProperties()['ID'])
          .split("_", 1).at(0)
          .split("-")?.at(2) ?? "J";
        return feature.getProperties().ELEV == this.selectedElevation && this.typeDisplay.includes(featType);
      }

      return feature.getProperties().ELEV == this.selectedElevation;
    }

    return feature.getProperties().ELEV == this.selectedElevation && feature.getProperties().NA == this.selectedNavaid.split("_")[0];
  }

  private changeFeaturesStyle(features: Feature<Geometry>[]){
    for (const feat of features){
      let zIndex = undefined;
      this.savedStyles.push(feat.getStyle() as () => Style[]);
      if (this.calcType == "DocAndSectorizationDisplay"){
        this.moveFeatureUp(feat);
      } else {
        // coverage is the only possibility
        zIndex = this.mapService.layerFrontZIndex;
      }
      feat.setStyle(this.getStyleFunctionForFeatureWithColor(feat, AnalysisToolService.ANALYSIS_TOOL_COLOR, zIndex));
      this.previouslyModifiedFeatures.push(feat);
    }

  }

  private moveFeatureUp(feature: Feature<Geometry>){
    const layerToBeMoved = this.layers.find(layer => layer.olLayer.getSource().getFeatures()[0].getProperties().ID == feature.getProperties().ID);
    this.mapService.moveLayersToFront([layerToBeMoved]);

  }

  private restorePreviouslyChangedFeatures(toBeChangedFeatures?: Feature<Geometry>[]){
    const alreadyChangedFeatures = [];
    const alreadySavedStyles = [];
    let toBeChangedFeatureIndex = -1;
    for (let i=0; i<this.savedStyles.length; i++){
      const featureToBeRestored = this.previouslyModifiedFeatures[i];

      if (toBeChangedFeatures){
        // if feature is to be changed, there is no need to restore it
        toBeChangedFeatureIndex = toBeChangedFeatures.findIndex(feat => feat.getProperties().ID == featureToBeRestored.getProperties().ID);
      }
      if (toBeChangedFeatureIndex > -1){
        toBeChangedFeatures.splice(toBeChangedFeatureIndex, 1);
        alreadyChangedFeatures.push(featureToBeRestored);
        alreadySavedStyles.push(this.savedStyles[i]);
        continue;
      }

      const isHiddenFeature: boolean = this.hiddenFeatures.findIndex(feat => feat.getProperties().ID == featureToBeRestored.getProperties().ID) > -1;

      if (isHiddenFeature)
        continue;

      featureToBeRestored.setStyle(this.savedStyles[i]);
    }
    this.previouslyModifiedFeatures = alreadyChangedFeatures;
    this.savedStyles = alreadySavedStyles;

  }

  getStyleFunctionForFeatureWithColor(feat:Feature<Geometry>, rgbColor: string, zIndex: number){
    return function() {
      const zoom = this.map.getView().getZoom();
      let text = this.selectedElevation + '';
      if (zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT || !feat.get("hasLabel")){
        text = "";
      }
      return [
        new Style({
      stroke: new Stroke({
        color: rgbColor,
      }),
      text: new Text({
            text: text,
            font: 'bold ' + 13 + 'px Calibri,sans-serif',
            offsetY: 0,
            overflow: false,
        fill: new Fill({
          color: rgbColor
        }),
      }),
      zIndex: zIndex
        })
      ];
    }.bind(this)
  }

  isNavaidDiscreteCalculation(): boolean {
    return this.calcType != "PERFORMANCE"
            && this.calcType != "Cumulative Coverage"
            && this.calcType != "Overlap";
  }

  isPairsAnalysis(){
    return this.calcType == "PERFORMANCE" && this.layerName == this.getPairsAnalysisFlag();
  }

  getPairsAnalysisFlag(){
    return AnalysisToolService.PAIRS_ANALYSIS_FLAG;
  }

  isCritical(): boolean{
    return this.criticallity == "CRITICAL";
  }

  isFeatureCritical(feature: Feature<Geometry>, criticalNavaid: string): boolean{
    const featurePairs: Pair[] = this.parseFeaturePairs(feature);

		for (const pair of featurePairs) {

			//If neither the left nor the rigth is the selected navAid,
			//then there is at least one pair that does not contain it, thus it is not a critical navAid
			if(pair.left != criticalNavaid && pair.right != criticalNavaid){
				return false;
			}
		}

		return true;
  }

  setNavaidInfoForPairsAnalysis(){
    this.navaids_info = new Map<string, String[]>();
    this.selectedNavaids = [];
    for (const feat of this.features){
      if (feat.getProperties().PAIR_IDS == null || feat.getProperties().PAIR_IDS == ""){
        continue;
      }
      const pairs: string[] = feat.getProperties().PAIR_IDS.split(" ");
      for (const pairString of pairs){
        const pair: Pair = this.parsePair(pairString);
        if (!this.navaids_info.has(pair.left)){
          this.navaids_info.set(pair.left, []);
          this.selectedNavaids.push(pair.left);
        }
        if (!this.navaids_info.has(pair.right)){
          this.navaids_info.set(pair.right, []);
          this.selectedNavaids.push(pair.right);
        }
      }
    }
  }

  private parseFeaturePairs(feat: Feature<Geometry>): Pair[] {
    const toReturn: Pair[] = [];
    if (feat.getProperties().PAIR_IDS == null || feat.getProperties().PAIR_IDS == ""){
      return [];
    }
    const pairs: string[] = feat.getProperties().PAIR_IDS.split(" ");
    for (const pairString of pairs){
      const pair: Pair = this.parsePair(pairString);
      toReturn.includes(pair)? false : toReturn.push(pair);
    }
    return toReturn;
  }

  private parsePair(pairString: string): Pair {
    const parsedPair: string[] = pairString.split(",");
    const navFeatureIdLeft = parsedPair[0].substring(1).split("_");
    const navFeatureIdRight = parsedPair[1].substring(0, parsedPair[1].length - 1).split("_");

    const leftId = navFeatureIdLeft[0] + "_" + NavaidModel.getTypeFromNumber(Number.parseInt(navFeatureIdLeft[2])) + "_" + navFeatureIdLeft[1];
    const rightId = navFeatureIdRight[0] + "_" + NavaidModel.getTypeFromNumber(Number.parseInt(navFeatureIdRight[2])) + "_" + navFeatureIdRight[1];

    return new Pair(leftId, rightId);
  }

  deSelectFeatures(){
    for (const feat of this.previouslySelectedFeatures){
      this.globalSelectionService.removeSelectedFeature(feat);
    }
    this.previouslySelectedFeatures = [];
  }

  closeWindow(){
    this.deSelectFeatures();
    this.restorePreviouslyChangedFeatures();
    this.showHiddenFeatures();
    this.active = false;
  }

  //#region Grit
  public isImpactAssessment(){
    return this.calcType == "Impact Assessment";
  }

  typeDisplay = ['J', 'S']

  get info(){
    if (!this.isImpactAssessment()) return this.navaids_info;

    let info = new Map<string, String[]>();
    this.navaids_info.forEach((value, key)=>{
      let type = key.split("_")[1];
      if (!this.typeDisplay.includes(type)) return;

      info.set(key, value)
    })

    return info;
  }

  public filterTransmitter(jamming: boolean = this.typeDisplay[0] == "J", spoofing: boolean = this.typeDisplay[1] == "S"){
    this.typeDisplay = [jamming ? "J" : "", spoofing ? "S" : ""];
    this.selectedNavaid = "ALL"
    this.onSelectChange()
  }
  //endregion

}

class Pair{
  left: string;
  right: string;

  constructor(left: string, right: string){
    this.left = left;
    this.right = right;
  }
}
